import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuestionTypeNamePipe } from './question-type-name-pipe/question-type-name.pipe';
import { ColumnConfigurationElementSettings } from '../column-configuration-element-settings/column-configuration-element-settings';

@Component({
  selector: 'lib-mixed-grid-configuration-dialog',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    CommonModule,
    MatExpansionModule,
    ColumnConfigurationElementSettings,
    QuestionTypeNamePipe,
  ],

  templateUrl: './mixed-grid-configuration-dialog.html',
  styleUrl: './mixed-grid-configuration-dialog.scss',
})
export class MixedGridConfigurationDialog {
  readonly dialogRef = inject(MatDialogRef<MixedGridConfigurationDialog>);
  readonly data = inject(MAT_DIALOG_DATA);

  onChangeQuestionType(): void {
    this.dialogRef.close({
      action: 'change-question-type',
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
  onFinish(): void {
    this.dialogRef.close();
  }
}
